import { useAuth } from '@/lib/auth/auth';
import type { OrganizationDetail } from '@/lib/api/apiTypes';
import { useQuery } from '@tanstack/react-query';

export const organizationKeys = {
  all: ['organizations'] as const,
  detail: (organizationID: string) => [...organizationKeys.all, organizationID] as const,
};

export function useOrganization(organizationID: string, enabled = true) {
  const session = useAuth((state) => state.session);
  const request = useAuth((state) => state.request);

  return useQuery({
    queryKey: organizationKeys.detail(organizationID),
    enabled: Boolean(session) && enabled && organizationID.length > 0,
    queryFn: () => request<OrganizationDetail>(`/organizations/${organizationID}`),
  });
}
